export default __webpack_public_path__ + "static/media/BlueKey.855226b7.svg";